module.exports = __webpack_public_path__ + "static/media/squirrel.74197081.png";